import { useState } from "react";
import { Send, Loader2 } from "lucide-react";
import { api, errText } from "../../lib/api";

// Pings IndexNow (Bing/Yandex) with the fresh URLs and resubmits the sitemap to Google Search Console.
export default function IndexPushButton({ label = "Push to Google & Bing", testid = "index-push" }) {
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const run = async () => {
    setBusy(true); setMsg("");
    try {
      const { data } = await api.post("/admin/seo/indexing/push", {});
      const bits = [
        data.indexnow?.ok ? `IndexNow ${data.indexnow.state === "accepted_pending_verification" ? "pending verification" : "accepted"}: ${data.indexnow.submitted} URLs (not a ranking guarantee)` : `IndexNow: ${data.indexnow?.reason || data.indexnow?.status}`,
        data.google?.ok ? "Google sitemap resubmitted" : `Google: ${data.google?.reason || data.google?.status}`,
      ];
      if (data.bing?.ok) bits.push("Bing accepted the batch");
      setMsg(bits.join(" · "));
    } catch (e) { setMsg(errText(e)); }
    setBusy(false);
  };
  return (
    <div className="flex flex-wrap items-center gap-2">
      <button className="btn-ghost text-xs px-4 inline-flex items-center gap-1.5" disabled={busy} onClick={run} data-testid={testid}>
        {busy ? <Loader2 size={13} className="animate-spin" /> : <Send size={13} />} {label}
      </button>
      {msg ? <span className="text-xs text-muted" data-testid={`${testid}-msg`}>{msg}</span> : null}
    </div>
  );
}
